import { graphql } from '@tn/foundation/graphql/__generated/gql';

export const redeemCouponCacheKey = 'redeemCoupon';
export const redeemCouponDocument = /* GraphQL */ `
    query RedeemCoupon($couponCode: String!) {
        redeemCoupon(couponCode: $couponCode) {
            message
            success
        }
    }
`;

export const redeemCouponQuery = graphql(redeemCouponDocument);
